import { ObjectValues } from "@/src/shared/types/objectValues";
import { DS_SIZE } from "@/src/design_system/shared/types/size";

export const DS_PALETTE_ITEM_SIZES = {
  ExtraSmall: DS_SIZE.ExtraSmall,
  Small: DS_SIZE.Small,
  Medium: DS_SIZE.Medium,
  Large: DS_SIZE.Large,
  ExtraLarge: DS_SIZE.ExtraLarge,
} as const;

export type DSPaletteItemSize = ObjectValues<typeof DS_PALETTE_ITEM_SIZES>;
